<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>
<template>
  <div class="img-text-cards-ordered p-bottom-xl-1 p-top-xl-1 max">
    <!-- eslint-disable vue/no-v-html -->
    <img
      class="block-decoration-img"
      src="@/assets/img/circle-arrow.png"
      alt="Istituto Canossiano"
    />
    <div v-if="block.titolo" class="title title-base" v-html="block.titolo" />

    <div class="blocks-container max-content">
      <div v-for="(card, index) in block.card" :key="index" class="block">
        <div class="left">
          <DefaultPicture
            :image="{ custom: card.immagine.responsiveImage }"
            :lazy-load="true"
            :alt="card.titolo"
          />
        </div>
        <div class="right">
          <div class="card-title title-base" v-html="card.titolo" />
          <div class="text-s-1-b" v-html="card.testo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListImageTextOrdered',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
